module.exports = __webpack_public_path__ + "img/children.af179a16.png";